import request from '@/modules/base/util/request'
import config from 'config'

const baseUrl = `${config.resourceHost}`

export const EconomicAssetService = {
  getAll: () => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}economicAssets`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getAllDepreciableAssets: () => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}economicAssets/depreciableassets`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getClassesLiveAndRecoverPeriod: () => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}economicAssets/classesliveandrecoverperiod`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getDepreciationMethods: () => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}economicAssets/depreciationmethods`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  addCalculate: (data) => {
    return new Promise((resolve, reject) => {
      const newData = { ...data, depreciationMethod: null }
      const url = `${baseUrl}economicAssets/calculate`
      return request(url, { auth: true, isConcurrent: true, method: 'POST', data: newData })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  add: (data) => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}economicAssets`
      return request(url, { auth: true, isConcurrent: true, method: 'POST', data })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  /**
   * @param {string} id
   * @returns {Promise<{ data: import('./economicAssetTypes').EconomicAsset }>}
   */
  getEconomicAsset: (id) => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}economicAssets/${id}`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },
  addSpecialDeprecation: (id, data) => {
    return new Promise((resolve, reject) => {
      const newData = { ...data }
      const url = `${baseUrl}economicAssets/${id}/addSpecialDeprecation`
      return request(url, { auth: true, isConcurrent: true, method: 'POST', data: newData })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },
}
